<template>
    <div class="background" :style="{'background': 'url(' + theImage + ')'}">
        <div class="transbox">
            <div class="transboxContent">
                <h2>{{ $t('meaning.Header') }}</h2>
                <h3>{{ $t('meaning.GeneralHeader') }}</h3>
                {{ $t('meaning.GeneralText1') }}
                <br />
                <br />
                {{ $t('meaning.GeneralText2') }}
                <br />
                <br />
                {{ $t('meaning.MeaningTae') }}
                <br />
                {{ $t('meaning.MeaningKwon') }}
                <br />
                {{ $t('meaning.MeaningDo') }}
                <br />
                <h3>{{ $t('meaning.DisciplineSubheader') }}</h3>
                <ol>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList1Bold') }}</strong> {{ $t('meaning.DisciplineList1Korean') }}<br />
                        {{ $t('meaning.DisciplineList1Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList2Bold') }}</strong> {{ $t('meaning.DisciplineList2Korean') }}<br />
                        {{ $t('meaning.DisciplineList2Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList3Bold') }}</strong> {{ $t('meaning.DisciplineList3Korean') }}<br />
                        {{ $t('meaning.DisciplineList3Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList4Bold') }}</strong> {{ $t('meaning.DisciplineList4Korean') }}<br />
                        {{ $t('meaning.DisciplineList4Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList5Bold') }}</strong> {{ $t('meaning.DisciplineList5Korean') }}<br />
                        {{ $t('meaning.DisciplineList5Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList6Bold') }}</strong> {{ $t('meaning.DisciplineList6Korean') }}<br />
                        {{ $t('meaning.DisciplineList6Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList7Bold') }}</strong> {{ $t('meaning.DisciplineList7Korean') }}<br />
                        {{ $t('meaning.DisciplineList7Text') }}
                    </li>
                    <li>
                        <strong>{{ $t('meaning.DisciplineList8Bold') }}</strong> {{ $t('meaning.DisciplineList8Korean') }}<br />
                        {{ $t('meaning.DisciplineList8Text') }}
                    </li>
                </ol>
                <br />
                {{ $t('meaning.DisciplineText') }}
                <br />
                <br />
                <h3>{{ $t('meaning.PrinciplesSubheader') }}</h3>
                <ol>
                    <li>{{ $t('meaning.PrinciplesList1') }}</li>
                    <li>{{ $t('meaning.PrinciplesList2') }}</li>
                    <li>{{ $t('meaning.PrinciplesList3') }}</li>
                    <li>{{ $t('meaning.PrinciplesList4') }}</li>
                    <li>{{ $t('meaning.PrinciplesList5') }}</li>
                </ol>
                <p>{{ $t('meaning.OathSubheadertext') }}</p>
                <ul>
                    <li>{{ $t('meaning.OathList1') }}</li>
                    <li>{{ $t('meaning.OathList2') }}</li>
                    <li>{{ $t('meaning.OathList3') }}</li>
                    <li>{{ $t('meaning.OathList4') }}</li>
                    <li>{{ $t('meaning.OathList5') }}</li>
                </ul>
                <br />
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import { EventBus } from '@/classes/eventBus.js';

    export default {
        props: {
            linkItem: String,
            myText: String
        },
        data: function () {
            return {
                theImage: '',
            }
        },
        computed: {
        },
        mounted() {
            EventBus.$on('backgroundImageChange', image => {
                this.theImage = image;
            });
        },
        methods: {
        }
    }
</script>

<style scoped>
    @import '../css/main.css';
</style>